(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flamengo-cart-line-image"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flamengo-cart-image')) {
    customElements.define('flamengo-cart-image', class extends HTMLElement {
      connectedCallback() {
        const apply = () => {
          const script = this.querySelector('[data-line-image]');
          if (!script) return;
          let data;
          try { data = JSON.parse(script.textContent); } catch (_) { return; }
          if (!data.color) return;
          const map = data.map || {};
          let mediaId = Number(data.nativeMedia) || 0;
          const correction = map.__nativeOverrides?.[data.color];
          if (Array.isArray(map.__missingColors) && map.__missingColors.includes(data.color)) {
            mediaId = 0;
          } else if (mediaId && correction && Array.isArray(correction.from) && correction.from.some(id => Number(id) === mediaId)) {
            mediaId = Number(correction.to) || 0;
          } else if (!mediaId) {
            mediaId = Number(map[data.color]) || 0;
          }
          const chosen = data.images?.[String(mediaId)];
          const img = this.querySelector('img');
          const missing = this.querySelector('.flamengo-cart-line-image__missing');
          if (img && chosen?.src) {
            img.src = chosen.src;
            img.alt = chosen.alt || '';
            img.hidden = false;
            missing.hidden = true;
          } else {
            if (img) img.hidden = true;
            if (missing) missing.hidden = false;
          }
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
        else apply();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flamengo-cart-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flamengo-cart-recommendations')) {
    customElements.define('flamengo-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('change', (event) => {
          const select = event.target.closest('[data-fcr-variant]');
          if (select) {
            event.stopPropagation();
            this.selectVariant(select);
          }
        });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-fcr-add]');
          if (button) {
            event.preventDefault();
            this.addVariant(button);
          }
        });
        this.querySelectorAll('[data-fcr-variant]').forEach((select) => {
          const options = Array.from(select.options).slice(1);
          const rank = (title) => {
            const value = title.split(' / ')[0].trim().toUpperCase();
            const sizes = ['XXXS','XXS','XS','S','M','L','XL','XXL','2XL','XXXL','3XL','4XL','5XL','6XL'];
            return /^\d+(\.\d+)?$/.test(value) ? Number(value) : sizes.indexOf(value) >= 0 ? sizes.indexOf(value) : 1000;
          };
          options.sort((a, b) => rank(a.textContent) - rank(b.textContent));
          options.forEach((option) => select.appendChild(option));
          this.selectVariant(select);
        });
        this.querySelectorAll('[data-fcr-add][data-default-variant]').forEach((button) => { button.disabled = false; });
      }

      selectVariant(select) {
        const card = select.closest('[data-fcr-card]');
        const option = select.selectedOptions[0];
        const button = card.querySelector('[data-fcr-add]');
        button.disabled = !select.value;
        button.dataset.variantId = select.value;
        if (!select.value) return;
        card.querySelector('[data-fcr-price]').textContent = option.dataset.price;
        card.querySelector('[data-fcr-product-link]').href = option.dataset.url;
        const image = card.querySelector('[data-fcr-image]');
        if (image) {
          let source = { url: option.dataset.image, alt: option.dataset.imageAlt };
          if (card.dataset.hasColor === 'true') {
            let data = { map: {}, images: {} };
            try { data = JSON.parse(card.querySelector('[data-fcr-media]')?.textContent || '{}'); } catch (_) {}
            const map = data.map || {};
            const color = option.dataset.color;
            let mediaId = Number(option.dataset.mediaId);
            if (!mediaId) {
              const sibling = Array.from(select.options).find((candidate) => candidate.dataset.color === color && Number(candidate.dataset.mediaId));
              mediaId = Number(sibling?.dataset.mediaId) || 0;
            }
            const correction = map.__nativeOverrides?.[color];
            if (Array.isArray(map.__missingColors) && map.__missingColors.includes(color)) {
              mediaId = 0;
            } else if (mediaId && correction && Array.isArray(correction.from) && correction.from.some((id) => Number(id) === mediaId)) {
              mediaId = Number(correction.to) || 0;
            } else if (!mediaId) {
              mediaId = Number(map[color]) || 0;
            }
            source = data.images?.[String(mediaId)] || {};
          }
          if (source.url) {
            image.src = source.url;
            image.removeAttribute('srcset');
            image.alt = source.alt || '';
            image.hidden = false;
          } else if (card.dataset.hasColor === 'true') {
            image.hidden = true;
          }
          const note = card.querySelector('[data-fcr-image-note]');
          if (note) note.hidden = !image.hidden;
        }
        this.querySelector('[data-fcr-status]').textContent = '';
      }

      async addVariant(button) {
        if (this.busy || button.disabled || !button.dataset.variantId) return;
        this.busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = this.dataset.adding;
        const status = this.querySelector('[data-fcr-status]');
        status.textContent = '';
        let added = false;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
          added = true;
          if (this.dataset.context === 'page') {
            window.location.reload();
            return;
          }
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function' || !result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          drawer.renderContents(result);
          drawer.classList.remove('is-empty');
          const liveStatus = drawer.querySelector('[data-fcr-status]') || drawer.querySelector('#CartDrawer-LiveRegionText');
          if (liveStatus) liveStatus.textContent = this.dataset.added;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'flamengo-cart-recommendations' } }));
          window.setTimeout(() => {
            const closeButton = drawer.querySelector('.drawer__close');
            closeButton?.focus({ preventScroll: true });
          }, 80);
        } catch (error) {
          if (added) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          status.textContent = error.message || this.dataset.error;
          button.disabled = false;
          button.textContent = this.dataset.add;
          button.removeAttribute('aria-busy');
          this.busy = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flamengo-collection-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flamengo-collection-gallery')) {
  customElements.define('flamengo-collection-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryReady) return;
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = this.querySelectorAll('.flamengo-collection-gallery__slide');
      if (!this.track || this.slides.length < 2) return;
      this.galleryReady = true;
      this.previous = this.querySelector('[data-gallery-previous]');
      this.next = this.querySelector('[data-gallery-next]');
      this.position = this.querySelector('[data-gallery-position]');
      this.currentIndex = 0;
      this.previous.hidden = false;
      this.next.hidden = false;
      this.position.hidden = false;
      this.updatePosition();
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updatePosition();
        });
      }, { passive: true });
      this.track.addEventListener('pointerdown', event => {
        this.pointerStart = { x: event.clientX, y: event.clientY };
        this.suppressClick = false;
      }, { passive: true });
      this.track.addEventListener('pointermove', event => {
        if (this.pointerStart && Math.abs(event.clientX - this.pointerStart.x) > 8) this.suppressClick = true;
      }, { passive: true });
      this.track.addEventListener('pointercancel', () => { this.suppressClick = true; this.pointerStart = null; });
      this.track.addEventListener('pointerup', () => { this.pointerStart = null; });
      this.track.addEventListener('click', event => {
        if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; }
      }, true);
    }
    move(direction) {
      const index = Math.min(this.slides.length - 1, Math.max(0, this.currentIndex + direction));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.track.clientWidth * index, behavior: reducedMotion ? 'auto' : 'smooth' });
    }
    updatePosition() {
      const width = this.track.clientWidth;
      this.currentIndex = width ? Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width))) : 0;
      this.previous.disabled = this.currentIndex === 0;
      this.next.disabled = this.currentIndex === this.slides.length - 1;
      this.slides.forEach((slide, index) => { slide.tabIndex = index === this.currentIndex ? 0 : -1; });
      this.position.querySelector('[data-gallery-position-visible]').textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
      this.position.querySelector('[data-gallery-position-accessible]').textContent = this.dataset.positionLabel.replace('[current]', this.currentIndex + 1);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
